import { Dialog } from "primereact/dialog";
import "./SubvendorDashboard.css";

import { Card } from "primereact/card";
import { useEffect, useState } from "react";
import { ILogin } from "../../../../models/Login";
import { JVSunEditor } from "../../../../shared/JVSuneditor";

interface IProps {
  open?: boolean,
  singleData?: any,
  setModel: (prev: { singleData: any, open: boolean }) => void,
  reload: () => void,
  modelData: any
}

export const POCDetails = (props: IProps) => {
  const [model, setModel] = useState(false);
  const [pocDetails, setPocDetails] = useState<any>(null);

  const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');

  const onHide = () => {
    setModel(false);
  };
  function handleJobDescription() {
    setModel(true);
  };


  useEffect(() => {
    // getSubvendorDetails();
  }, []);

  return (
    <>
      <Card title={<p className="flex justify-content-between"><span>POC Details</span><span className="pi pi-pencil mt-2" style={{ cursor: "pointer" }} onClick={() => props.setModel({ singleData: props.modelData, open: true })}></span></p>} style={{ marginBottom: "20px", backgroundColor: "#0093E9", backgroundImage: "linear-gradient(160deg, #0093E9 0%, #80D0C7 100%)", borderRadius: "10px", padding: "20px", color: "#F0F0F0", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", }}>
        <div style={{ fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif", }}>
          <p style={{ fontSize: "16px", margin: "10px 0", color: "#F0F0F0" }}>
            <strong style={{ color: "#FFD700" }}>Name :</strong>{" "}
            <span>{props?.modelData?.contact_Person_Name}</span>
          </p>
          <p style={{ fontSize: "16px", margin: "10px 0", color: "#F0F0F0" }}>
            <strong style={{ color: "#FFD700" }}>Email :</strong>{" "}
            <span>{`${props?.modelData?.contact_Person_EmailID || ""}`}</span>
          </p>
          <p style={{ fontSize: "16px", margin: "10px 0", color: "#F0F0F0" }}>
            <strong style={{ color: "#FFD700" }}>Phone :</strong>{" "}
            <span>{props?.modelData?.contact_Person_Phone_No}</span>
          </p>
          <p style={{ fontSize: "16px", margin: "10px 0", color: "#F0F0F0" }}>
            <strong style={{ color: "#FFD700" }}>Designation :</strong>{" "}
            <span>{props?.modelData?.designation_Name}</span>
          </p>
          {/* <p style={{ fontSize: "16px", margin: "10px 0", color: "#FFD700", cursor: "pointer", textDecoration: "underline", }} onClick={handleJobDescription}>
                Show Job Description
              </p> */}
        </div>
      </Card>

      <Dialog visible={model} style={{ width: "65vw" }} header="Job Description" modal className="p-fluid" onHide={onHide}>
        <p style={{ fontSize: "16px", margin: "10px 0", color: "black" }} onClick={handleJobDescription}>
          {<JVSunEditor value={`<p><b>Job Description -</b> \n${""}</p>`} />}
        </p>
      </Dialog>
    </>
  );
}